import * as Styled from './IntroModal.styles';
// Import Swiper React components
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperInterface } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useState } from 'react';


import EDIT from './EDIT.gif';
import PLAY from './PLAY.gif';
import SEND from './SEND.gif';
import slide2btnimg from './slide2btnimg.png';
import slide3btnimg from './slide3btnimg.png';
import slide4btnimg from './slide4btnimg.png';

interface IntroModalProps {
  onClick: () => void;
  animationComplete?: () => void;
  isOpen: boolean;
}

const variants = {
  show: { opacity: 1, display: 'flex' },
  hide: { opacity: 0, transitionEnd: { display: 'none' } }
};

export const IntroModal = ({ onClick, isOpen, animationComplete }: IntroModalProps) => {
  const [swiper, setSwiper] = useState<SwiperInterface | null>(null);
  const [slideIndex, setSlideIndex] = useState(0);
  return (
    <Styled.IntroModal
      animate={isOpen ? 'show' : 'hide'}
      variants={variants}
      initial={false}
      key={'introModal'}
      onAnimationComplete={(e) => {
        if (!isOpen && animationComplete) {
          animationComplete();
        }
      }}
    >
      <Styled.Overlay />
      <Styled.Card>
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          // navigation
          pagination={{ clickable: true }}
          onSwiper={(swiper) => setSwiper(swiper)}
          onSlideChange={(s) => {
            setSlideIndex(s.activeIndex);
          }}
          style={{ width: '100%' }}
        >
          <SwiperSlide>
            <Styled.Slide>
              <Styled.Content>
                <div className="content">
                  <h1>It's Interactive!</h1>
                  <p>Take your time to read the instructions!</p>
                </div>
                <Styled.Text>
                  Bring chaos or gravity into your new year and mix up the stickers to create your own holiday card.
                  Export and share your message to a friend, or send a message back to us!
                </Styled.Text>
                <Styled.Title>Happy Holidays!</Styled.Title>
                <svg xmlns="http://www.w3.org/2000/svg" width="79" height="44" viewBox="0 0 79 44" fill="none">
                  <path
                    d="M78.4134 36.9629L75.9883 18.7196C75.9645 18.5505 75.8483 18.4131 75.6977 18.3576L42.3726 0.146042C42.3012 0.101127 42.2167 0.074707 42.1295 0.074707C42.111 0.074707 42.0925 0.074707 42.074 0.0773491L35.6468 0.86732C35.4196 0.89374 35.2505 1.08661 35.2505 1.31647V3.43274L31.6525 1.46971C31.5785 1.41951 31.4914 1.39309 31.4016 1.39309C31.3831 1.39309 31.3646 1.39309 31.3461 1.39573L8.46889 4.20422C8.24171 4.23064 8.07264 4.42351 8.07264 4.65337V6.76964L4.41387 4.7749C4.35576 4.74848 4.28971 4.72999 4.22367 4.72999C4.20518 4.72999 4.18669 4.72999 4.16819 4.73263L1.34157 5.07874C1.11438 5.10516 0.945312 5.29803 0.945312 5.52788V24.0697C0.945312 24.1992 1.00079 24.3234 1.09853 24.4079C1.14872 24.4528 1.20948 24.4819 1.27288 24.5004L31.8982 42.5508C32.408 42.8996 33.0526 43.0819 33.8029 43.0819C34.0221 43.0819 34.252 43.066 34.4897 43.037L35.1158 42.9603C36.3548 42.8071 37.3084 42.2813 37.9477 41.428L39.1946 42.107C39.2712 42.1651 39.3637 42.1968 39.4614 42.1968H39.4878L42.3409 41.8454C42.5654 41.819 42.7345 41.6261 42.7345 41.3989V41.3672L43.2179 41.6314C43.2892 41.679 43.3738 41.7027 43.4609 41.7027C43.4609 41.7027 43.4821 41.7027 43.4874 41.7027C43.4953 41.7027 46.0657 41.3857 46.0657 41.3857C46.2902 41.3593 46.4593 41.1664 46.4593 40.9392V39.8903L48.5066 40.9999C48.5674 41.0317 48.636 41.0554 48.7074 41.0554H48.7391L51.0664 40.7701C51.291 40.7437 51.46 40.5508 51.46 40.3236V40.2972L51.954 40.564C52.0227 40.6063 52.102 40.6274 52.1865 40.6274H52.2129L62.1933 39.4015C62.4178 39.3751 62.5869 39.1822 62.5869 38.955V38.5613L63.6489 39.1373C63.7123 39.1717 63.7836 39.1928 63.8602 39.1928H63.8919L65.0437 39.0501C65.2445 39.0263 65.4056 38.8678 65.4347 38.667L65.4928 38.2522L66.4253 38.7569C66.5151 38.8044 66.5944 38.844 66.6868 38.844H66.7185L67.4371 38.7569L67.482 38.7516L69.3972 38.5164L70.3112 38.4055L72.4959 38.136C72.7073 38.1096 72.8684 37.9457 72.8869 37.7344L72.9952 36.63L75.0188 37.7344C75.0848 37.7687 75.1588 37.7952 75.2327 37.7952H75.2644L78.0171 37.457C78.136 37.4411 78.2443 37.3803 78.3183 37.2852C78.3922 37.1901 78.4239 37.0686 78.4081 36.9497L78.4134 36.9629ZM7.52845 23.1662L1.55291 23.9006V5.65999L4.07838 5.35087V20.857C4.07838 20.8993 4.09687 20.9416 4.12857 20.968C4.15499 20.9918 4.19197 21.005 4.22895 21.005C4.23424 21.005 4.24216 21.005 4.24745 21.005L7.53109 20.6007V23.1662H7.52845ZM11.2031 22.7144L8.67759 23.0235V4.78547L11.2031 4.47635V22.7144V22.7144ZM19.5799 5.83436L17.3371 6.10913C17.2631 6.11706 17.205 6.18311 17.205 6.25709V21.9746L14.7033 22.2811V6.60319C14.7033 6.56092 14.6848 6.51865 14.6531 6.49223C14.6267 6.46845 14.5897 6.45524 14.5527 6.45524C14.5475 6.45524 14.5395 6.45524 14.5343 6.45524L12.3258 6.72737V4.33632L19.5773 3.44595V5.837L19.5799 5.83436ZM27.6054 4.84888L25.3626 5.12365C25.2886 5.13158 25.2305 5.19763 25.2305 5.2716V20.9891L22.7288 21.2956V5.61771C22.7288 5.57544 22.7103 5.53317 22.6786 5.50675C22.6522 5.48297 22.6152 5.46976 22.5782 5.46976C22.573 5.46976 22.565 5.46976 22.5598 5.46976L20.3513 5.74189V3.35084L27.6028 2.46047V4.85152L27.6054 4.84888ZM28.7308 2.32044L31.2563 2.01132V17.5175C31.2563 17.5597 31.2747 17.602 31.3064 17.6284C31.3329 17.6522 31.3698 17.6654 31.4068 17.6654C31.4121 17.6654 31.42 17.6654 31.4253 17.6654L34.709 17.2612V19.8266L28.7334 20.5611V2.32309L28.7308 2.32044ZM38.2885 30.2046L35.8132 30.5084V27.4119C35.8132 27.0975 35.8132 26.1464 34.8912 26.1464C34.8305 26.1464 34.7644 26.1517 34.6931 26.1596C33.8583 26.2626 33.6866 26.8254 33.6866 27.6365V38.6512C33.6866 39.7423 34.1806 39.9696 34.5954 39.9696C34.6456 39.9696 34.6984 39.9669 34.7539 39.959C35.2347 39.9009 35.8106 39.5891 35.8106 38.4504V34.2707L38.2858 33.9668V38.0831C38.2858 40.6565 37.1948 42.0964 35.0418 42.3606L34.4157 42.4372C34.2018 42.4636 33.9957 42.4769 33.8002 42.4769C32.8043 42.4769 32.0778 42.1255 31.6393 41.428C31.288 40.8705 31.1083 40.0884 31.1083 39.0977V27.7818C31.1083 26.4449 31.531 24.149 34.3523 23.8029L35.0022 23.7236C35.2505 23.6919 35.4883 23.6787 35.7049 23.6787C37.9715 23.6787 38.2832 25.2824 38.2832 27.0156V30.1966L38.2885 30.2046ZM35.8555 19.6866V1.44593L41.9816 0.692945V3.08399L38.513 3.50936C38.4391 3.51729 38.3809 3.58334 38.3809 3.65732V8.51868C38.3809 8.56095 38.3994 8.60322 38.4311 8.62964C38.4575 8.65342 38.4945 8.66663 38.5315 8.66663C38.5368 8.66663 38.5447 8.66663 38.55 8.66663L41.2076 8.33902V10.8542L38.513 11.1845C38.4391 11.1924 38.3809 11.2585 38.3809 11.3325V16.6905C38.3809 16.7328 38.3994 16.7751 38.4311 16.8015C38.4575 16.8253 38.4945 16.8385 38.5315 16.8385C38.5368 16.8385 38.5447 16.8385 38.55 16.8385L42.1322 16.3972V18.9125L35.8555 19.6839V19.6866ZM42.1374 41.2721L39.612 41.5812V23.3405L42.1374 23.0314V41.2721ZM50.863 40.1994L48.8236 40.4504L46.1555 30.2415C46.137 30.1755 46.0789 30.1306 46.0102 30.1306C46.0049 30.1306 45.997 30.1306 45.9917 30.1306C45.9177 30.1412 45.8623 30.2046 45.8623 30.2785V40.8124L43.6115 41.0898V22.8491L45.8992 22.5691L48.2926 32.0883C48.3085 32.1544 48.3692 32.2019 48.4379 32.2019C48.4432 32.2019 48.4511 32.2019 48.4564 32.2019C48.5304 32.1914 48.5885 32.128 48.5885 32.054V22.2414L50.8656 21.9614V40.2021L50.863 40.1994ZM58.6138 39.2483L52.3371 40.0198V21.7791L58.4632 21.0261V23.4172L54.9946 23.8425C54.9207 23.8504 54.8625 23.9165 54.8625 23.9905V28.8492C54.8625 28.8915 54.881 28.9337 54.9127 28.9602C54.9392 28.9839 54.9761 28.9971 55.0131 28.9971C55.0184 28.9971 55.0263 28.9971 55.0316 28.9971L57.6892 28.6695V31.1848L54.9946 31.515C54.9207 31.5229 54.8625 31.589 54.8625 31.663V37.021C54.8625 37.0633 54.881 37.1056 54.9127 37.132C54.9392 37.1558 54.9761 37.169 55.0131 37.169C55.0184 37.169 55.0263 37.169 55.0316 37.169L58.6138 36.7278V39.243V39.2483ZM69.1912 37.9484L66.84 38.2364V26.4185C66.84 26.3393 66.7793 26.2758 66.7 26.2679C66.6974 26.2679 66.6921 26.2679 66.6895 26.2679C66.6155 26.2679 66.5521 26.3234 66.5415 26.3974L64.8561 38.4794L63.9896 38.5851L62.2857 26.9548C62.2752 26.8809 62.2118 26.828 62.1378 26.828C62.1352 26.828 62.1299 26.828 62.1272 26.828C62.048 26.8333 61.9872 26.8994 61.9872 26.9786V38.8335L59.7603 39.1056V20.8676L63.1073 20.4554L64.4361 29.9377C64.4467 30.0117 64.5101 30.0672 64.584 30.0672C64.658 30.0672 64.7214 30.0117 64.732 29.9377L66.0924 20.0882L69.1859 19.7077V37.9484H69.1912ZM75.3754 37.1901L75.0161 33.8981C75.0108 33.8585 74.9924 33.8215 74.9607 33.7977C74.9342 33.7766 74.9025 33.766 74.8682 33.766C74.8629 33.766 74.855 33.766 74.8497 33.766L72.7733 34.0197C72.7046 34.0276 72.6492 34.0831 72.6412 34.1544L72.3031 37.5679L70.0867 37.8401L72.3242 19.3246L75.4124 18.9442L77.7978 36.8916L75.3728 37.1901H75.3754ZM73.9674 24.4079L74.7176 31.1689C74.7255 31.2508 74.6674 31.3248 74.5882 31.3327L73.1141 31.515C73.1141 31.515 73.1009 31.515 73.0956 31.515C73.056 31.515 73.019 31.4992 72.9899 31.4727C72.9582 31.441 72.9424 31.3961 72.945 31.3512L73.6689 24.4079C73.6768 24.3313 73.7402 24.2732 73.8168 24.2732C73.8934 24.2732 73.9568 24.3313 73.9647 24.4053L73.9674 24.4079Z"
                    fill="#FBF8F0"
                  />
                </svg>
              </Styled.Content>
            </Styled.Slide>
          </SwiperSlide>
          <SwiperSlide>
            <Styled.Slide>
              <Styled.Instructions>
                <Styled.TutImage src={EDIT} />
                <Styled.RightSideSlide>
                  <Styled.ButtonImage src={slide2btnimg} />
                  <div>
                    <Styled.TutTitle>Create a message</Styled.TutTitle>
                    <Styled.TutText>
                      Arrange and resize the words and stickers to create your own holiday message. You can resize,
                      rotate and delete items by double clicking them. You can also click and drag to select multiple
                      items.
                    </Styled.TutText>
                  </div>
                </Styled.RightSideSlide>
              </Styled.Instructions>
            </Styled.Slide>
          </SwiperSlide>
          <SwiperSlide>
            <Styled.Slide>
              <Styled.Instructions>
                <Styled.TutImage src={PLAY} />
                <Styled.RightSideSlide>
                  <Styled.ButtonImage src={slide3btnimg} />
                  <div>
                    <Styled.TutTitle>Have fun</Styled.TutTitle>
                    <Styled.TutText>
                      Have fun and add low gravity or bring chaos to your canvas with the play mode. You can click and
                      drag items to throw them across your screen.
                    </Styled.TutText>
                  </div>
                </Styled.RightSideSlide>
              </Styled.Instructions>
            </Styled.Slide>
          </SwiperSlide>
          <SwiperSlide>
            <Styled.Slide>
              <Styled.Instructions>
                <Styled.TutImage src={SEND} />
                <Styled.RightSideSlide>
                  <Styled.ButtonImage src={slide4btnimg} />
                  <div>
                    <Styled.TutTitle>Save and share</Styled.TutTitle>
                    <Styled.TutText>
                      Click the "Save as Image" button to download your message and send off to a friend or post on
                      social media!
                    </Styled.TutText>
                  </div>
                </Styled.RightSideSlide>
              </Styled.Instructions>
            </Styled.Slide>
          </SwiperSlide>
        </Swiper>

        <Styled.ButtonWrapper>
          <Styled.Button
            onClick={() => {
              swiper && swiper.slidePrev();
            }}
          >
            Back
          </Styled.Button>
          <Styled.SkipButton onClick={onClick}>Skip</Styled.SkipButton>
          <Styled.Button
            onClick={() => {
              if (swiper?.isEnd) {
                onClick();
                return;
              }
              swiper && swiper.slideNext();
            }}
          >
            {slideIndex === 3 ? 'Finish' : 'Continue'}
          </Styled.Button>
        </Styled.ButtonWrapper>
      </Styled.Card>
    </Styled.IntroModal>
  );
};
